import http from "@/common/http.service";
const CREATE_ADV_AUTOMATION = "panel/advanced-automation";
const ROOT_URL = "panel/advanced-automation/list";
const ACTIVATE = "panel/advanced-automation/activate/";
const INACTIVATE = "panel/advanced-automation/inactivate/";
const DELETE_URL = "panel/advanced-automation/delete/";
const DUPLICATE_AUTO = "panel/advanced-automation/duplicate/";
const REPORT_LIST = "panel/advanced-automation/report-list";
const SAVE_URL = "panel/advanced-automation/save/";
const GET_AUTOMATION_ANALYTICS_DATA = "panel/advanced-automation/report/";

export default {
  getAutomationAnalyticalData(id, type, params) {
    return http
      .post(GET_AUTOMATION_ANALYTICS_DATA + id + "/" + type, params)
      .then((response) => {
        return response.data;
      });
  },
  createAdvAutomation(params) {
    return http.post(CREATE_ADV_AUTOMATION, params);
  },
  saveAdvAutomation(id, action, params) {
    return http.post(SAVE_URL + id + "/" + action, params);
  },
  fetchItems(params, cb) {
    http.post(ROOT_URL, params).then((response) => {
      var data = {
        items: response.data,
        total: response.count,
        allowtemplate: response.allowtemplate,
      };
      cb(data);
    });
  },
  fetchReportItems(params, cb) {
    http.post(REPORT_LIST, params).then((response) => {
      var data = {
        items: response.data,
        total: response.count,
        automationCount: response.automationCount,
      };
      cb(data);
    });
  },

  activateAuto(params) {
    const url = ACTIVATE + params.id;
    return http.post(url, {});
  },

  markAsPredefined(id) {
    const url = "panel/advanced-automation/template/" + id + "/create";
    return http.post(url, {});
  },

  deactivateAuto(params) {
    const url = INACTIVATE + params.id;
    return http.post(url, {});
  },
  delete(id) {
    return http.deleteRecord(DELETE_URL + id);
  },
  duplicateAutomation(params) {
    const url = DUPLICATE_AUTO + params.id;
    delete params.id;
    return http.post(url, params);
  },
  getAutomationActivitiesData(id, params) {
    return http.post(GET_AUTOMATION_ANALYTICS_DATA + id + "/activity", params);
  },
};
